import type { CartDiagnosticEvent, CartStoreConfiguration } from "../types/cart.types";

const defaultConfiguration: CartStoreConfiguration = {
    concurrencyMode: "legacy",
};

let currentConfiguration: CartStoreConfiguration = { ...defaultConfiguration };
let wasConfigured = false;

export const configureCartStore = (configuration: CartStoreConfiguration): void => {
    if (wasConfigured) {
        if (currentConfiguration.concurrencyMode === configuration.concurrencyMode) return;

        throw new Error("El store del carrito ya fue configurado con otro modo de concurrencia.");
    }

    currentConfiguration = { ...configuration };
    wasConfigured = true;
};

export const getCartStoreConfiguration = (): Readonly<CartStoreConfiguration> =>
    currentConfiguration;

export const reportCartDiagnostic = (event: CartDiagnosticEvent): void => {
    const reporter = currentConfiguration.diagnosticReporter;
    if (!reporter) return;

    try {
        void Promise.resolve(reporter(event)).catch((error) => {
            console.error("No se pudo reportar el diagnóstico del carrito.", error);
        });
    } catch (error) {
        console.error("No se pudo iniciar el reporte de diagnóstico del carrito.", error);
    }
};

export const resetCartStoreConfigurationForTests = (): void => {
    currentConfiguration = { ...defaultConfiguration };
    wasConfigured = false;
};
